import {
  ActionType,
  Gender,
  LinkType,
  ResourceDefinition
} from '@case-app/angular-library'

export const userDefinition: ResourceDefinition = {
  title: 'Collaborateurs',
  nameSingular: 'collaborateur',
  namePlural: 'collaborateurs',
  className: 'User',
  icon: 'icon-user',
  mainIdentifier: 'name',
  slug: 'users',
  path: 'collaborateurs',
  gender: Gender.Masculine,
  hasDetailPage: true,
  hasListPage: true,
  buttons: [LinkType.CREATE, LinkType.EXPORT],
  defaultLink: LinkType.DETAIL,
  childrenThatPreventDelete: [],
  dropdownLinks: [
    {
      label: 'Modifier',
      permission: 'editUsers',
      action: (user) => ({
        type: ActionType.Link,
        link: {
          path: `${userDefinition.path}/${user.id}/edit`
        }
      })
    },
    {
      label: 'Supprimer',
      permission: 'deleteUsers',
      action: (user) => ({
        type: ActionType.Delete,
        delete: {
          itemToDelete: user,
          definition: userDefinition
        }
      })
    }
  ]
}
